export const SET_DASHBOARD_PREFERENCE = "SET_DASHBOARD_PREFERENCE";

export interface DashboardPreferenceState {
  dashboardPreference: "old" | "new" | "";
}

export interface SetDashboardPreferenceAction {
  type: typeof SET_DASHBOARD_PREFERENCE;
  payload: "old" | "new";
}
export type DashboardPreferenceActionTypes = SetDashboardPreferenceAction;

export const initialState: DashboardPreferenceState = {
  dashboardPreference: "",
};

export default function dashboardPreference(
  // eslint-disable-next-line default-param-last
  state = initialState,
  action: DashboardPreferenceActionTypes,
): DashboardPreferenceState {
  if (action.type === SET_DASHBOARD_PREFERENCE) {
    return {
      ...state,
      dashboardPreference: action.payload,
    };
  }

  return state;
}
